// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class treatmentAPI extends MainAPI {
    /**
     * @param queryParams
     * @return {object} Treatment List
     * */
    async getTreatmentList(queryParams) {
    	return API.get(`${ENDPOINTS.GET_TREATMENTS}?${queryString.stringify(queryParams)}`)
    }
	/**
     * @return {object} product types
     */
    async getProductTreatmentFrequency() {
    	return API.get(`${ENDPOINTS.GET_TREATMENTS_FREQUENCY}`);
    }
}

export default new treatmentAPI();